<template>
  <div>
    <v-sheet outlined>
      <v-data-table
        :items="items"
        :headers="headers"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`item.logo`]="{ item }">
          <v-img
            v-if="item.logo"
            width="50"
            height="50"
            :src="item.logo.thumbnailFileUrl"
          ></v-img>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          {{
            item.description.length > 30
              ? item.description.slice(0, 30) + '...'
              : item.description
          }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ StatsDisplayName(item.status) }}
        </template>
        <template v-slot:[`item.title`]="{ item }">
          <v-btn text @click="openModal(item)">{{ item.title }}</v-btn>
        </template>
        <template v-slot:[`item.startDateUtc`]="{ item }">
          <span v-if="item.startDateUtc">
            {{ item.startDateUtc | moment }}</span
          >
        </template>
        <template v-slot:[`item.endDateUtc`]="{ item }">
          <span v-if="item.endDateUtc"> {{ item.endDateUtc | moment }}</span>
        </template>
        <template v-slot:[`item.price`]="{ item }">
          {{ item.totalPrice.amount | priceSplitter }}

          {{
            item.totalPrice.title
              ? item.totalPrice.title
              : item.totalPrice.currency
          }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom v-if="item.status == 'Draft'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                @click="paymentItem(item)"
                v-if="item.status == 'Draft'"
                ><v-icon v-bind="attrs" v-on="on">mdi-cash</v-icon></v-btn
              >
            </template>
            <span>پرداخت</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 'Draft'"
                icon
                color="error"
                @click="deleteItem(item)"
                ><v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon></v-btn
              >
            </template>
            <span>حذف</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.durationInMonth`]="{ item }">
          <span>{{ item.durationInMonth }}</span>
        </template>
        <template v-slot:[`item.itemsCount`]="{ item }">
          <span>{{ item.items.length }}</span>
        </template>
      </v-data-table>
    </v-sheet>
    <div class="text-center pt-2 pt-5">
      <v-row>
        <v-col cols="12" sm="2" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="10" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-if="dialogMembershipPlans"
      v-model="dialogMembershipPlans"
      max-width="800px"
    >
      <v-card>
        <v-card-title>جزییات حق اشتراک</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <show-detail-subscription
              :selectedToSeeDetail="selectedSubsToShow"
            ></show-detail-subscription>
       
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            @click="
              dialogMembershipPlans = false;
              selectedSubsToShow = null;
            "
            >بستن</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const enumRepository = () => RepoFactory.get('enums');
const subscriptionRepository = () => RepoFactory.get('subscription');
import ShowDetailSubscription from './ShowDetailSubscription.vue';
import Helper from '@/core/helpers';
export default {
  components: {
    ShowDetailSubscription,
  },
  data() {
    return {
      selectedMembership: null,
      paymentId: null,
      statuses: [],
      pageNumber: 1,
      itemsPerPage: 10,
      pageCount: 1,
      dialogMembershipPlans: false,
      price: {
        amount: null,
        currency: null,
      },
      subsList: [],
      statusList: [],
      selectedSubsToShow: null,
      selected: null,
      openForm: false,
      isEdit: false,
      items: [],
      headers: [
        { sortable: true, text: ' لوگو', value: 'logo' },
        { sortable: true, text: ' عنوان', value: 'title' },
        { sortable: true, text: ' توضیحات', value: 'description' },
        { sortable: true, text: ' قیمت', value: 'price' },
        { sortable: true, text: 'تاریخ شروع', value: 'startDateUtc' },
        { sortable: true, text: 'تاریخ پایان', value: 'endDateUtc' },
        { sortable: true, text: ' مدت به ماه', value: 'durationInMonth' },
        { sortable: true, text: 'وضعیت', value: 'status' },
        { sortable: true, text: 'اقدام', value: 'actions' },
      ],
    };
  },
  computed: {
    subscriptionBaseUrl() {
      return this.$store.getters.subscriptionBaseUrl;
    },
    MerchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    this.getStatus();
    if (this.MerchantId) {
      this.getData();
    }
  },
  watch: {
    MerchantId(aft, bef) {
      this.getData();
    },
    pageNumber(aft, bef) {
      this.getData();
    },
    itemsPerPage(aft, bef) {
      this.pageNumber = 1;
    },
  },
  methods: {
    openModal(item) {
      
      // this.selectedSubsToShow = this.subsList.filter((x) => {
      //   return x.id == item.subscriptionPlanId;
      // });
      // this.selectedSubsToShow = this.selectedSubsToShow[0];
      this.selectedSubsToShow = item;
      this.dialogMembershipPlans = true;
    },
    StatsDisplayName(title) {
      if (this.statuses.length) {
        let result = this.statuses.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    showSubsDetail() {
      this.dialog = true;
    },
    getData() {
      const loader = this.$loading.show();
      let params = {
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
      };
      subscriptionRepository()
        .getData(
          this.subscriptionBaseUrl,
          { MerchantId: this.$store.getters.currentMerchant },
          params
        )
        .then((res) => {
          this.items = res.data.list;
          this.pageCount = Math.ceil(res.data.totalCount / this.itemsPerPage);
          loader.hide();
        })
        .catch((err) => {
          // Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    deleteItem(item) {
      let app = this;
      this.$dialog.error({
        text: ` آیا از حذف این آیتم اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              subscriptionRepository()
                .deleteData(item.id, this.subscriptionBaseUrl)
                .then(() => {
                  app.items.splice(
                    app.items.map((e) => e.id).indexOf(item.id),
                    1
                  );
                  this.$dialog.message.success('با موفقیت حذف گردید', {
                    position: 'top-left',
                  });
                  loader.hide();
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                  loader.hide();
                });
            },
          },
        },
      });
    },
    paymentItem(item) {
      this.selectedMembership = item;
      this.$router.push({
        path: `/financial-management/subscription/payment/${item.id}`,
      });
    },
    getStatus() {
      let app = this;
      const loader = this.$loading.show();
      enumRepository()
        .getEnum('MembershipStatus', this.subscriptionBaseUrl)
        .then((res) => {
          app.statuses = res.data;
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
